import _extends from "@babel/runtime/helpers/extends";
import React, { useEffect, useState, useCallback } from 'react';
import { IPublicEnumPluginRegisterLevel } from '@rchh/lowcode-types';

/**
 * HOC: provide view plugin context to a component.
 *
 * @param {React.ComponentType} Component - Component to wrap.
 * @param {string|string[]} viewName - View name or list of names used to filter view plugin context.
 * @returns {React.ComponentType} Returns the wrapped component.
 *
 * @example
 * // Usage example (function component):
 * const EnhancedComponent = ProvideViewPluginContext(MyComponent, "viewName");
 */
export var ProvideViewPluginContext = function ProvideViewPluginContext(Component, viewName) {
  // Create a function component so Hooks can be used inside
  return function WithPluginContext(props) {
    var _props$pluginContext;
    var getPluginContextFun = useCallback(function (editorWindow) {
      if (!(editorWindow !== null && editorWindow !== void 0 && editorWindow.currentEditorView)) {
        return null;
      }
      if (viewName) {
        var items = editorWindow === null || editorWindow === void 0 ? void 0 : editorWindow.editorViews.filter(function (d) {
          return d.viewName === viewName || Array.isArray(viewName) && viewName.includes(d.viewName);
        });
        return items[0];
      } else {
        return editorWindow.currentEditorView;
      }
    }, []);
    var _ref = props.pluginContext || {},
      workspace = _ref.workspace;
    var _useState = useState(getPluginContextFun(workspace === null || workspace === void 0 ? void 0 : workspace.window)),
      pluginContext = _useState[0],
      setPluginContext = _useState[1];
    useEffect(function () {
      if (workspace !== null && workspace !== void 0 && workspace.window) {
        var ctx = getPluginContextFun(workspace.window);
        ctx && setPluginContext(ctx);
      }
      return workspace === null || workspace === void 0 ? void 0 : workspace.onChangeActiveEditorView(function () {
        var ctx = getPluginContextFun(workspace.window);
        ctx && setPluginContext(ctx);
      });
    }, [workspace, getPluginContextFun]);
    if (((_props$pluginContext = props.pluginContext) === null || _props$pluginContext === void 0 ? void 0 : _props$pluginContext.registerLevel) !== IPublicEnumPluginRegisterLevel.Workspace || !props.pluginContext) {
      return /*#__PURE__*/React.createElement(Component, props);
    }
    return /*#__PURE__*/React.createElement(Component, _extends({}, props, {
      pluginContext: pluginContext
    }));
  };
};